import React from 'react';
import AntdProForm, {
  ProFormText,
  ProFormTextArea,
  ProFormDigit,
  ProFormSelect,
} from '@ant-design/pro-form';
import { Descriptions, Space, Typography } from 'antd';
import PropTypes from 'prop-types';
import ProForm from '../../../layout/ProForm';
import { ENUM_EMAIL_CATEGORIES } from '../../../../constants/form';
import { ENUM_EMAIL_TEMPLATE_LEGENDS } from '../../../../constants/emailTemplates';
import { HtmlInput, RecipientsInput } from '../../../input';

const { Text } = Typography;

const getReicipentsForInit = (recipients) =>
  recipients?.map(({ type, role, level }) => {
    switch (type) {
      case 'PL':
      case 'APPROVER':
        return { type };
      case 'ROLE':
        return { type, level, role: role.id };
      default:
        return null;
    }
  });

const EmailTemplateForm = ({ onFinish, initialValues }) => {
  const [form] = AntdProForm.useForm();

  return (
    <ProForm
      form={form}
      requiredMark={false}
      onFinish={onFinish}
      initialValues={{
        ...initialValues,
        to: getReicipentsForInit(initialValues.to),
        cc: getReicipentsForInit(initialValues.cc),
      }}
      onValuesChange={(values) => {
        form.validateFields(['html']);
        values.to?.forEach((_value, index) => {
          form.validateFields([
            ['to', index, 'level'],
            ['to', index, 'role'],
          ]);
        });
      }}
    >
      <ProFormDigit
        width="xl"
        name="emailId"
        label="Email ID"
        min={0}
        fieldProps={{ precision: 0 }}
        rules={[{ required: true }]}
      />
      <ProFormSelect
        width="xl"
        name="category"
        label="Email Category"
        valueEnum={ENUM_EMAIL_CATEGORIES}
        rules={[{ required: true }]}
      />
      <ProFormText
        width="xl"
        name="name"
        label="Name"
        rules={[{ required: true }, { whitespace: true }]}
      />
      <ProFormTextArea
        width="xl"
        name="description"
        label="Description"
        placeholder="Please enter (optional)"
      />
      <ProFormText
        width="xl"
        name="subject"
        label="Email Subject"
        rules={[{ required: true }, { whitespace: true }]}
      />
      <ProFormText
        width="xl"
        name="senderEmail"
        label="Sender's email"
        rules={[{ type: 'email' }, { required: true }, { whitespace: true }]}
      />
      <ProFormText
        width="xl"
        name="senderName"
        label="Sender's name"
        rules={[{ required: true }, { whitespace: true }]}
      />
      <RecipientsInput
        name="to"
        label="To..."
        form={form}
        creatorButtonText="Add To..."
        rules={[
          { required: true, message: 'Please enter at least 1 recipient to' },
        ]}
      />
      <RecipientsInput
        name="cc"
        label="Cc..."
        form={form}
        creatorButtonText="Add Cc..."
      />
      <HtmlInput
        form={form}
        label="Email Body"
        extraBefore={
          <Descriptions>
            <Descriptions.Item label={<Text type="secondary">Legends</Text>}>
              <Space direction="vertical" size={0}>
                {initialValues.legends?.map((legend) => (
                  <Text type="secondary" key={legend}>
                    {`${legend}: ${ENUM_EMAIL_TEMPLATE_LEGENDS[legend]}`}
                  </Text>
                ))}
              </Space>
            </Descriptions.Item>
          </Descriptions>
        }
        placeholder="Please Enter"
        required={true}
        requiredMessage="Please enter email body"
      />
    </ProForm>
  );
};

EmailTemplateForm.defaultProps = {
  initialValues: {},
};

EmailTemplateForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default EmailTemplateForm;
